const joinClassNames = (...parts) => parts.filter(Boolean).join(' ')

export default function ErrorState({ title = 'Error', message = '', action = null, className = '' }) {
  return (
    <article className={joinClassNames('gg-error', className)} role="alert">
      <h3 className="gg-error__title">{title}</h3>
      <p className="gg-error__message">{message}</p>
      {action ? <div className="gg-error__action">{action}</div> : null}
    </article>
  )
}
